import { useEffect, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { connectToHubUser } from "src/redux/slices/hub";
import { getUserSuccess } from "src/redux/slices/user";
import buildHubUrl from "./buildHubUrl";
import CreateConnection from "./HubMatrix";

export default function useHubUsers() {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.authJwt);
  const isConnectedRef = useRef(false); // Para evitar múltiples conexiones

  // Función optimizada para evitar recreación en cada render
  const handleUserUpdate = useCallback(
    (updatedUser) => {
      dispatch(getUserSuccess(updatedUser));
    },
    [dispatch]
  );

  useEffect(() => {
    if (!user || isConnectedRef.current) return;

    isConnectedRef.current = true; // Evita conexiones repetidas

    const cleanup = CreateConnection(
      buildHubUrl("/hub/userhub", { restauranteId: user.id }),
      [
        {
          id: `user/${user.id}`,
          operator: handleUserUpdate,
        },
      ],
      dispatch,
      connectToHubUser,
      "user"
    );

    return () => {
      cleanup(); // Asegura que la conexión se cierra al desmontar
      isConnectedRef.current = false;
    };
  }, [user, dispatch, handleUserUpdate]);
}
